import { useTranslation } from 'react-i18next';

const ProductPreparationTime = ({ prepareFrom, prepareTo }) => {
  const { t } = useTranslation();

  if (!prepareFrom && !prepareTo) {
    return '';
  }

  if (prepareFrom && !prepareTo) {
    return `${prepareFrom} ${t('products.minutesAbbreviation')}`;
  }

  if (!prepareFrom && prepareTo) {
    return `${prepareTo} ${t('products.minutesAbbreviation')}`;
  }

  return `${prepareFrom} - ${prepareTo} ${t('products.minutesAbbreviation')}`;
};

export default ProductPreparationTime;
